var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"port-slot-pill",class:{ 'is-free': !_vm.slot.equipmentName }},[_c('span',{staticClass:"port-position"},[_vm._v(_vm._s(_vm.slot.position))]),_c('span',{staticClass:"port-name"},[_vm._v(_vm._s(_vm.slot.equipmentName || "livre"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }